import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

const Subscriptions = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header title="SUBSCRIPTIONS" subtitle="Manage school subscription plans and billing" />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        mt="80px"
        gap="16px"
      >
        <CreditCardOutlinedIcon sx={{ fontSize: 64, color: colors.grey[400] }} />
        <Typography variant="h4" color={colors.grey[300]} fontWeight="600">
          Subscriptions Coming Soon
        </Typography>
        <Typography variant="h6" color={colors.grey[400]} textAlign="center" maxWidth="400px">
          Subscription management, billing cycles, and plan upgrades will be available here.
        </Typography>
      </Box>
    </Box>
  );
};

export default Subscriptions;
